// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background: #212529;
    color: white;
    padding: 40px 10px;
}

.footer-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    color: white;
    padding-left: 130px;
    background-color: #212529;
width: 100%;
}

.footer-section-company-info {
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between; /* Center content vertically */
    gap: 20px; /* Adds spacing between elements */
    height: 20vh;
}

.footer-section {
    flex: 1 1;
    min-width: 200px;
    margin: 10px;
}

.footer-section-sub-title-style {
    font-size: 16px;
    font-weight: 500;
    color: #ffff;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
    max-width: 10px;
}

.footer-nav-link-style {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
    padding: 5px;
}

.footer-section h3 {
    font-size: 20px;
    margin-bottom: 10px;
}

.footer-section p {
    font-size: 14px;
    color: #ccc;
    max-width: 300px;
}

.social-icons {
    margin-top: 10px;
    width:30%;
    gap: 20px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between; /* Center content vertically */
}

.social-icons a {
    color: white;
    margin-right: 10px;
    font-size: 18px;
    text-decoration: none;
}

.footer-section h4 {
    font-size: 16px;
    margin-bottom: 10px;
}

.footer-section ul {
    list-style: none;
    padding: 0;
}

.footer-section ul li {
    margin-bottom: 8px;
}

.footer-section ul li a {
    text-decoration: none;
    color: #ccc;
    font-size: 14px;
}

.footer-section ul li a:hover {
    color: white;
}

.fab-footer-icon {
   height: 18px;
   width: 18px;
   transition: transform 0.3s ease-in-out, filter 0.3s ease-in-out; /* Smooth transition */
}

.fab-footer-icon:hover {
    transform: scale(1.2); /* Slightly enlarges the icon */
    filter: brightness(1.2); /* Increases brightness */
}

/* Responsive Design */
@media (max-width: 768px) {
    .footer-container {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .footer-section {
        margin-bottom: 20px;
    }

    .social-icons a {
        margin: 0 5px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B,WAAW;AACX;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B,EAAE,8BAA8B;IAC9D,SAAS,EAAE,kCAAkC;IAC7C,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B,EAAE,8BAA8B;AAClE;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;GACG,YAAY;GACZ,WAAW;GACX,+DAA+D,EAAE,sBAAsB;AAC1F;;AAEA;IACI,qBAAqB,EAAE,+BAA+B;IACtD,uBAAuB,EAAE,yBAAyB;AACtD;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".footer {\n    background: #212529;\n    color: white;\n    padding: 40px 10px;\n}\n\n.footer-container {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    color: white;\n    padding-left: 130px;\n    background-color: #212529;\nwidth: 100%;\n}\n\n.footer-section-company-info {\n    width: 30%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between; /* Center content vertically */\n    gap: 20px; /* Adds spacing between elements */\n    height: 20vh;\n}\n\n.footer-section {\n    flex: 1;\n    min-width: 200px;\n    margin: 10px;\n}\n\n.footer-section-sub-title-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: #ffff;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n    max-width: 10px;\n}\n\n.footer-nav-link-style {\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n    padding: 5px;\n}\n\n.footer-section h3 {\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.footer-section p {\n    font-size: 14px;\n    color: #ccc;\n    max-width: 300px;\n}\n\n.social-icons {\n    margin-top: 10px;\n    width:30%;\n    gap: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between; /* Center content vertically */\n}\n\n.social-icons a {\n    color: white;\n    margin-right: 10px;\n    font-size: 18px;\n    text-decoration: none;\n}\n\n.footer-section h4 {\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.footer-section ul {\n    list-style: none;\n    padding: 0;\n}\n\n.footer-section ul li {\n    margin-bottom: 8px;\n}\n\n.footer-section ul li a {\n    text-decoration: none;\n    color: #ccc;\n    font-size: 14px;\n}\n\n.footer-section ul li a:hover {\n    color: white;\n}\n\n.fab-footer-icon {\n   height: 18px;\n   width: 18px;\n   transition: transform 0.3s ease-in-out, filter 0.3s ease-in-out; /* Smooth transition */\n}\n\n.fab-footer-icon:hover {\n    transform: scale(1.2); /* Slightly enlarges the icon */\n    filter: brightness(1.2); /* Increases brightness */\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .footer-container {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .footer-section {\n        margin-bottom: 20px;\n    }\n\n    .social-icons a {\n        margin: 0 5px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
